import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@ipc/ipc-components';
import {
  getData,
  getColumns,
  getIsLoading,
} from '../redux/selectors/BalanceOnHandTransactionsHistorySelectors';
import ListTable from '../../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../../common/TableDefinitions';
import { tableLoadData } from '../../../../../../common/tables/actions/ListTableActions';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import BalanceModificationTransactionsEdit from '../../../balance-modification/edit/containers/BalanceModificationTransactionsEdit';
import BalanceModificationTransactionsDelete from '../../../balance-modification/delete/containers/BalanceModificationTransactionsDelete';
import { getUserRole } from '../../../../../../common/user/redux/selectors/UserDataSelectors';

class BalanceOnHandTransactionsHistoryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      showDeleteModal: false,
    };
    this.editTransaction = this.editTransaction.bind(this);
    this.deleteTransaction = this.deleteTransaction.bind(this);
  }

  componentDidMount() {
    this.props.tableLoadData({ tableId: 'BALANCE_ON_HAND_TRANSACTIONS_HISTORY' }, this.props.appContext.appContext, { transactionId: this.props.row.original.id });
  }

  refreshHistories = () => {
    this.props.tableLoadData({ tableId: 'BALANCE_ON_HAND_TRANSACTIONS_HISTORY' }, this.props.appContext.appContext, { transactionId: this.props.row.original.id });
  }

  showEditFormModal = () => {
    this.setState({
      showModal: true,
    });
  }

  hideEditFormModal = () => {
    this.setState({
      showModal: false,
    });
  }

  showDeleteFormModal = () => {
    this.setState({
      showDeleteModal: true,
    });
  }

  hideDeleteFormModal = () => {
    this.setState({
      showDeleteModal: false,
    });
  }

  editTransaction() {
    this.setState({
      showModal: true,
    });
  }

  deleteTransaction() {
    this.setState({
      showDeleteModal: true,
    });
  }

  render() {
    const {
      showModal,
      showDeleteModal,
    } = this.state;
    return (
      <div>
        {this.props.row.original.status !== 'DELETED'
        && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER'))
        && (
          <Button className="action-buttons" onClick={this.editTransaction}>Edit</Button>
        )}
        {this.props.row.original.status !== 'DELETED'
        && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER'))
        && (
          <Button className="action-buttons" onClick={this.deleteTransaction}>
            Delete
          </Button>
        )}
        <br />
        <br />
        <ListTable
          listId={TableDefinitions.BALANCE_ON_HAND_TRANSACTIONS_HISTORY.id}
          loading={this.props.isLoading}
          columns={this.props.columns}
          data={this.props.data}
        />
        {showModal && (
          <BalanceModificationTransactionsEdit
            closeDialog={this.hideEditFormModal}
            openDialog={this.showEditFormModal}
            row={this.props.row.original}
            refreshTransactions={this.props.refreshTransactions}
            refreshHistories={this.refreshHistories}
          />
        )}
        {showDeleteModal && (
          <BalanceModificationTransactionsDelete
            closeDialog={this.hideDeleteFormModal}
            openDialog={this.showDeleteFormModal}
            row={this.props.row.original}
            refreshTransactions={this.props.refreshTransactions}
            refreshHistories={this.refreshHistories}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
    userRole: getUserRole(state),
  };
}

BalanceOnHandTransactionsHistoryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  row: PropTypes.objectOf(PropTypes.shape),
  isLoading: PropTypes.bool,
  userRole: PropTypes.arrayOf(PropTypes.string),
  refreshTransactions: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BalanceOnHandTransactionsHistoryContainer);
